import type { TOC } from '@ember/component/template-only';
import type { TdComponentSignature } from '@mylighthouse/prism-ember/types/components/prism/table';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

const NetRevenueCostDrilldownSectionTdName = <template>
  <div class="flex items-center gap-100">
    <span class="truncate">{{@displayValue}}</span>
    {{#if @row.nameTooltip}}
      <GeneralIconWithTooltip
        @size="small"
        @tooltipContent={{@row.nameTooltip}}
      />
    {{/if}}
  </div>
</template> satisfies TOC<TdComponentSignature>;

export default NetRevenueCostDrilldownSectionTdName;
